import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M15 9a2 2 0 1 0 -4 0v5a2 2 0 0 1 -2 2h6","key":"svg-1"}],["path",{"d":"M9 12h4","key":"svg-2"}]]

const IconCoinPound = createReactComponent('outline', 'coin-pound', 'CoinPound', __iconNode);

export default IconCoinPound;